import type { DiscountList, DiscountTypeList, SubscriptionData } from '@/models/interface/pay';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class PayService extends ApiFactory {
  constructor() {
    super('Pay');
  }

  /**
   * 驗證一般方案的推薦碼是否有效
   * @param mgmCode
   * @returns
   */
  isMGMExist(mgmCode: string): Promise<ApiDataResponse<boolean>> {
    return this.post(`MGMExist`, {
      mgmCode: mgmCode
    });
  }

  /**
   * 取得當前使用者是否註冊時帶有推薦碼(是否有推薦人)
   * @returns
   */
  getRecommendCode(): Promise<ApiDataResponse<string>> {
    return this.get(`GetRecommendCode`);
  }

  /**
   * 取得訂閱方案（用來檢查是否已有訂閱）
   * @returns
   */
  getSubscription(): Promise<ApiDataResponse<SubscriptionData | null>> {
    return this.get(`GetSubscription`);
  }

  /**
   * 取得折扣碼的代表意義與值
   * @param discountCode
   * @returns
   */
  discount(discountCode: string): Promise<ApiDataResponse<DiscountList>> {
    return this.get(`Discount?discountCode=${discountCode}`);
  }

  /**
   * 取得折扣碼的type列表
   * @returns
   */
  discountTypeList(): Promise<ApiDataResponse<DiscountTypeList>> {
    return this.get(`DiscountTypeList`);
  }

  
  getContractTemplate(): Promise<ApiDataResponse<{
    ipAddress: string;
    template: string;
  }>> {
    return this.get(`GetContractTemplate`);
  }
}
